import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import {
  STheHeader, SCancellingBookingDialog, SStrapiService, SCheckoutHeader,
} from '@slg/web-customer-shared';
import appConfig from '@/appConfig';
import { skipToMainContent } from '@/utils/skipToMainContent';
import {
  useStore, useRouter, useRouteRef, useCmsLocaleReload, useGlobalErrorDialog, useGtm,
} from '@/composables';


const __default__ = {
  name: 'TheHeader',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isHeaderShown: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



const store = useStore();
const router = useRouter();
const route = useRouteRef();
const { setGlobalError } = useGlobalErrorDialog();
const { trackGtmEvent } = useGtm();

const isLoadingLogOut = ref(false);
const isCancelingBookingDialogOpen = ref(false);
const languages = ref<string[] | null>(null);
const toolbarItems = ref([
  {
    strapiText: '',
    strapiKey: 'homeTitle',
    text: 'header.home',
    value: 'Booking',
  },
  {
    text: 'header.about',
    value: 'About',
  },
  {
    text: 'header.nightCard',
    value: 'NightCard',
  },
  {
    strapiText: '',
    strapiKey: 'FAQTitle',
    text: 'header.faq',
    value: 'FAQ',
  },
  {
    strapiText: '',
    strapiKey: 'contactUsTitle',
    text: 'header.contactUs',
    value: 'ContactUs',
  },
]);
const cabinetToolbarItems = ref([
  {
    text: 'cabinet.myTrips',
    icon: 'mdi-ticket-confirmation',
    value: 'Trips',
  },
  {
    text: 'cabinet.settings',
    icon: 'mdi-cog',
    value: 'Profile',
  },
  {
    text: 'cabinet.logOut',
    icon: 'mdi-logout-variant',
    value: 'LogOut',
  },
]);

languages.value = appConfig.languages;

const getAuthToken = computed(() => store.getters['auth/getAuthToken']);
const getFirstLetters = computed(() => store.getters['auth/getFirstLetters']);
const getFullName = computed(() => store.getters['auth/getFullName']);
const getStrappiCoreSettings = computed(() => store.getters['common/getStrappiCoreSettings']);
const getStrappiCoreMenu = computed(() => store.getters['common/getStrappiCoreMenu']);
const getAdults = computed(() => store.getters['booking/getAdults']);
const getChildren = computed(() => store.getters['booking/getChildren']);
const getTripType = computed(() => store.getters['booking/getTripType']);
const getRideType = computed(() => store.getters['booking/getRideType']);
const getTemporaryReservationRemainingTime = computed(() => store.getters['booking/getTemporaryReservationRemainingTime']);
const getIgnoreRemainingTime = computed(() => store.getters['booking/getIgnoreRemainingTime']);
const getAnimalsTransportation = computed(() => store.getters['booking/getAnimalsTransportation']);
const getVehicleCategoryId = computed(() => store.getters['booking/getVehicleCategoryId']);
const getVehicleCategories = computed(() => store.getters['opsZone/getVehicleCategories']);
const getSelectedFeatures = computed(() => store.getters['booking/getSelectedFeatures']);
const getTemporaryReservationDeadline = computed(() => store.getters['booking/getTemporaryReservationDeadline']);
const getPaymentType = computed(() => store.getters['booking/getPaymentType']);
const getAppConfig = computed(() => appConfig);
const getCurrentLang = computed(() => route.value.params.lang);
const getLogoRedirectPath = computed(() => {
  const { defaultLanguage } = appConfig;
  const currentLang = route.value.params.lang || defaultLanguage;
  return { name: 'Booking', params: { lang: currentLang } };
});
// due to problems with specific header and cookie banner on Chekout Page
const isCheckoutPage = computed(() => route.value.name === 'Checkout');

function onTrackEventReservationExpired() {
  trackGtmEvent('Booking-Expired-Dialog-Ok-Button-Click', 'Button', 'Click', 'Redirect to home page');
}

async function loadCmsData() {
  try {
    const res = await SStrapiService.getCoreSettings();
    store.commit('common/setStrappiCoreSettings', res);
  } catch (error) {
    // to-do rethink about catch
  }
}

function setLang(lang: string) {
  if (lang === getCurrentLang.value) {
    return;
  }
  router.push({
    name: route.value.name,
    params: {
      ...route.value.params,
      lang,
    },
    query: route.value.query,
  }).catch(() => {});
}

function toAuthPage() {
  router.push({ name: 'Auth' });
}

async function logOut() {
  isLoadingLogOut.value = true;
  try {
    store.commit('booking/clearTemporaryReservation');
  } catch (e) {
    await setGlobalError(e as any);
  }
  isLoadingLogOut.value = false;
  store.commit('auth/clearAuthTokenAndProfileInfo');
  if (route.value.name !== 'Booking') {
    await router.push({ name: 'Booking' });
  }
}

function updateRemainingTime(remainingTime: number) {
  store.commit('booking/setRemainingTime', remainingTime);
}

useCmsLocaleReload(loadCmsData);

return { __sfc: true,store, router, route, setGlobalError, trackGtmEvent, isLoadingLogOut, isCancelingBookingDialogOpen, languages, toolbarItems, cabinetToolbarItems, getAuthToken, getFirstLetters, getFullName, getStrappiCoreSettings, getStrappiCoreMenu, getAdults, getChildren, getTripType, getRideType, getTemporaryReservationRemainingTime, getIgnoreRemainingTime, getAnimalsTransportation, getVehicleCategoryId, getVehicleCategories, getSelectedFeatures, getTemporaryReservationDeadline, getPaymentType, getAppConfig, getCurrentLang, getLogoRedirectPath, isCheckoutPage, onTrackEventReservationExpired, loadCmsData, setLang, toAuthPage, logOut, updateRemainingTime, STheHeader, SCancellingBookingDialog, SCheckoutHeader, skipToMainContent }
}

})